module.exports = "pegasus_template/assets/tech/large/2.png";